export { default as UserOrganizationIcon } from './UserOrganizationIcon';
